import Vue from 'vue';
import Router from 'vue-router';
import HelloWorld from '@/components/HelloWorld';
import GuidePage from '@/pages/GuidePage';
import GoodsDetail from '@/pages/GoodsDetail';
import GoodsCategoryDetail from '@/pages/GoodsCategoryDetail';
import GoodsCategory from '@/pages/GoodsCategory';
import Index from '@/pages/index/Index';
import GoodsList from '@/pages/GoodsList';
import Order from '@/pages/Order';
import NewOrder from '@/pages/NewOrder';
import OrderStep3 from '@/pages/OrderStep3';
import OrderStep4 from '@/pages/OrderStep4';
import Cart from '@/pages/Cart';
import comment from '@/pages/comment/comment';
import logistics from '@/pages/logistics/logistics';
import siteDetail from '@/pages/siteDetail';
import Success from '@/pages/OrderSuccess';
import DetailSuccess from '@/pages/Detailsuccess/Detailsuccess';
import Test from '@/pages/Test';
import HomeIndex from '@/pages/Index';
import CategoryDetail3 from '@/pages/index/detail/Detail3'
import CategoryDetail4 from '@/pages/index/detail/Detail4'
import navHead from '@/pages/navHead/navIndex'
import CategoryDetail2 from '@/pages/index/detail/Detail2'
import Detail from '@/pages/index/detail/newDetail'
import home from '@/api/home';
import goods from '@/api/goods';
import { Store } from 'vuex';
Vue.use(Router);

const router = new Router({
    // mode: 'history', //去掉url中的#
    routes: [
        {
            path: '/',
            name: 'navHead',
            component: navHead,
            children: [{
                path: '/',
                name: 'HomeIndex',
                component: HomeIndex
            }, 
            {
                path: '/GoodsCategory/:searchValue?',
                name: 'GoodsCategory',
                component: GoodsCategory,
            },
            {
                path: '/CategoryDetail4/:prodId/',
                name: 'GoodsCategoryDetail',
                component: CategoryDetail3,
                meta:{
                    title:'',
                    keepAlive:true
                }
            },
            {
                path: '/CategoryDetail/:prodId/',
                name: 'GoodsCategoryDetail4',
                component: CategoryDetail4,
                meta:{
                    title:'',
                    keepAlive:true
                }
            },
            {
                path: '/CategoryDetail3/:prodId/',
                name: 'GoodsCategoryDetail',
                component: CategoryDetail2,
            },
         ],
        }, 
        {
            path: '/Detail/:prodId/',
            name: 'Detail',
            component: CategoryDetail3,
        },
        {
            path: '/guide',
            name: 'GuidePage',
            component: GuidePage,
        }, {
            path: '/detail/:prodId/',
            name: 'GoodsDetail',
            component: GoodsDetail,

        }, 
        {
            path: '/CategoryDetail2/:prodId/',
            name: 'GoodsCategoryDetail2',
            component: GoodsCategoryDetail,

        }, 
        {
            path: '/GoodsCategory/:searchValue?',
            name: 'GoodsCategory',
            component: GoodsCategory,

        }, {
            path: '/goodslist/:categoryId',
            name: 'GoodsList',
            component: GoodsList,

        }, {
            path: '/test',
            name: 'Test',
            component: Test,
        }, 
        // {
        //     path: '/',
        //     name: 'HomeIndex',
        //     component: HomeIndex,
        // },
         , {
            path: '/order',
            name: 'Order',
            component: Order,
        }, {
            path: '/index',
            name: 'Index',
            component: Index,
        }, {
            path: '/cart',
            name: 'Cart',
            component: Cart,
        }, {
            path: '/siteDetail/:id',
            name: 'siteDetail',
            component: siteDetail,
        },
        {
            path: '/newOrder',
            name: 'NewOrder',
            component: NewOrder,
        },
        // {
        //     path: '/familymart_callback',
        //     name: 'OrderStep3',
        //     component: OrderStep3,
        // }, 
        {
            path: '/orderStep3',
            name: 'OrderStep3',
            component: OrderStep3,
        },
        {
            path: '/orderStep4/:id',
            name: 'OrderStep4',
            component: OrderStep4,
        }, {
            path: '/success',
            name: 'Success',
            component: Success,
        },
        {
            path: '/DetailSuccess',
            name: 'DetailSuccess',
            component: DetailSuccess,
        },
        {
            path: '/comment/:id',
            name: 'comment',
            component: comment,
        },
        {
            path: '/logistics',
            name: 'logistics',
            component: logistics,
        }
    ],
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
          return savedPosition
        } else {
          return {
            x: 0,
            y: 0
          }
        }
      }
});

router.beforeEach((to, from, next) => {
    let status;
        let url = location.host;
        if(!sessionStorage.getItem('shopLogo')){
            home.region(url).then(res => {
                // var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                // link.type = 'image/x-icon';
                // link.rel = 'shortcut icon';
                // link.href =  sessionStorage.getItem('shopLogo') || res.shopLogo
                // sessionStorage.setItem('shopLogo',res.shopLogo)
                sessionStorage.setItem('shopId',res.shopId)
                sessionStorage.setItem('shopName',res.shopName)
                // document.getElementsByTagName('head')[0].appendChild(link);
                document.title = sessionStorage.getItem('shopName') || res.shopName
            })
        }        

        
    // }
    // var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    //     link.type = 'image/x-icon';
    //     link.rel = 'shortcut icon';
    //     link.href = sessionStorage.getItem('shopLogo');
    //     document.getElementsByTagName('head')[0].appendChild(link);
    //     document.title = sessionStorage.getItem('title')

    if (sessionStorage.getItem("MarketStatus")) {
        status = sessionStorage.getItem("MarketStatus")
    }
    // console.log('===status===', status)
    if (status == 'start') {
        sessionStorage.setItem("MarketStatus", 'end');
        next({
            name: 'OrderStep3'
        });
    } else {
        next()
    }
});
// router.beforeEach((to, from, next) => {
//     console.log('to.fullPath', to)
//     console.log('=====from===', from)
//         // location.href = "http://localhost:8080/#" + to.fullPath;
//     next();
// });


// router.beforeEach((to, from, next) => {
//   console.log("====to=====global====", window)
//   if (window.test == 'start') {
//     window.test = 'end'
//     next({
//       name: 'OrderStep3'
//     });
//   } else {
//     next()
//   }

// });
export default router


// WEBPACK FOOTER //
// ./src/router/index.js